import React from 'react';
import PropTypes from 'prop-types';
import { FiTrash2 } from 'react-icons/fi';
import {
  Button,
  TextInput,
  ToolTip,
  Select,
} from '../../../components';

/* WARNING: This component assumes any props passed are immutable
 * E.G. If you update the benefit.name in a parent component, this component
 * will not re-render. You must pass a new benefit object with the new name.
 * (const newBenefit = { ...oldBenefit, name: newName };)
*/

const propTypes = {
  benefit: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    category: PropTypes.string,
    subcategory: PropTypes.string,
    order: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    languageId: PropTypes.string.isRequired,
    planBenefitCategoryId: PropTypes.number,
    planBenefitCategory: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  typeDropDownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  benefitCategoryDropDownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

function EditBenefit({
  benefit,
  onChange,
  onDelete,
  typeDropDownOptions,
  benefitCategoryDropDownOptions,
}) {
  const handleChange = event => onChange(event, benefit.id);
  const handleSelectChange = (name, value) => handleChange({ target: { name, value } });
  const handleDelete = () => onDelete(benefit.id);
  const selectedTypeValueIndex = typeDropDownOptions.map(obj => obj.value).indexOf(benefit.type);
  const defaultSelectedTypeValueIndex = selectedTypeValueIndex === -1 ? 0 : selectedTypeValueIndex;
  const selectedBenefitCategory = benefit.planBenefitCategory == null
    ? benefitCategoryDropDownOptions.find(x => x.id === 0)
    : benefitCategoryDropDownOptions.find(x => x.id === benefit.planBenefitCategory.id);
  return (
    <tr>
      <td>
        <TextInput
          name="name"
          value={benefit.name}
          onChange={handleChange}
        />
      </td>
      <td>
        <TextInput
          name="value"
          value={benefit.value || ''}
          onChange={handleChange}
        />
      </td>
      <td>
        <Select
          name="type"
          defaultSelectedItem={typeDropDownOptions[defaultSelectedTypeValueIndex]}
          value={benefit.type}
          data={typeDropDownOptions}
          onChange={item => handleSelectChange('type', item.id)}
        />
      </td>
      <td>
        <TextInput
          name="category"
          value={benefit.category || ''}
          onChange={handleChange}
        />
      </td>
      <td>
        <TextInput
          name="subcategory"
          value={benefit.subcategory || ''}
          onChange={handleChange}
        />
      </td>
      <td>
        <Select
          name="planBenefitCategory"
          defaultSelectedItem={selectedBenefitCategory}
          data={benefitCategoryDropDownOptions}
          onChange={item => handleSelectChange('planBenefitCategory', { id: item.id, name: item.text })}
        />
      </td>
      <td>
        <TextInput
          name="order"
          value={benefit.order}
          type="number"
          onChange={handleChange}
        />
      </td>
      <td>
        <TextInput
          name="languageId"
          value={benefit.languageId}
          type="number"
          onChange={handleChange}
        />
      </td>
      <td>
        <ToolTip content="Delete plan benefit">
          <Button
            variant="danger"
            onClick={handleDelete}
            iconStart={<FiTrash2 />}
            aria-label="Delete plan benefit"
          />
        </ToolTip>
      </td>
    </tr>
  );
}

EditBenefit.propTypes = propTypes;
export default React.memo(EditBenefit);
